import React, { useState, useEffect } from 'react';
import { CheckCircleIcon, InformationCircleIcon, ChevronDownIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import { apiService as api } from '../../services/api';
import API_CONFIG from '../../config/api';
import { getComuniByProvincia, searchComuni, getDefaultComuni } from '../../utils/comuni';

// Dati delle province italiane (identico al ClientForm originale)
const PROVINCE_ITALIANE = [
  { codice: '001', nome: 'Torino', sigla: 'TO', regione: 'Piemonte' },
  { codice: '002', nome: 'Vercelli', sigla: 'VC', regione: 'Piemonte' },
  { codice: '003', nome: 'Novara', sigla: 'NO', regione: 'Piemonte' },
  { codice: '004', nome: 'Cuneo', sigla: 'CN', regione: 'Piemonte' },
  { codice: '005', nome: 'Asti', sigla: 'AT', regione: 'Piemonte' },
  { codice: '006', nome: 'Alessandria', sigla: 'AL', regione: 'Piemonte' },
  { codice: '007', nome: 'Valle d\'Aosta', sigla: 'AO', regione: 'Valle d\'Aosta' },
  { codice: '008', nome: 'Imperia', sigla: 'IM', regione: 'Liguria' },
  { codice: '009', nome: 'Savona', sigla: 'SV', regione: 'Liguria' },
  { codice: '010', nome: 'Genova', sigla: 'GE', regione: 'Liguria' },
  { codice: '011', nome: 'La Spezia', sigla: 'SP', regione: 'Liguria' },
  { codice: '012', nome: 'Varese', sigla: 'VA', regione: 'Lombardia' },
  { codice: '013', nome: 'Como', sigla: 'CO', regione: 'Lombardia' },
  { codice: '014', nome: 'Sondrio', sigla: 'SO', regione: 'Lombardia' },
  { codice: '015', nome: 'Milano', sigla: 'MI', regione: 'Lombardia' },
  { codice: '016', nome: 'Bergamo', sigla: 'BG', regione: 'Lombardia' },
  { codice: '017', nome: 'Brescia', sigla: 'BS', regione: 'Lombardia' },
  { codice: '018', nome: 'Pavia', sigla: 'PV', regione: 'Lombardia' },
  { codice: '019', nome: 'Cremona', sigla: 'CR', regione: 'Lombardia' },
  { codice: '020', nome: 'Mantova', sigla: 'MN', regione: 'Lombardia' },
  { codice: '021', nome: 'Bolzano', sigla: 'BZ', regione: 'Trentino Alto Adige' },
  { codice: '022', nome: 'Trento', sigla: 'TN', regione: 'Trentino Alto Adige' },
  { codice: '023', nome: 'Verona', sigla: 'VR', regione: 'Veneto' },
  { codice: '024', nome: 'Vicenza', sigla: 'VI', regione: 'Veneto' },
  { codice: '025', nome: 'Belluno', sigla: 'BL', regione: 'Veneto' },
  { codice: '026', nome: 'Treviso', sigla: 'TV', regione: 'Veneto' },
  { codice: '027', nome: 'Venezia', sigla: 'VE', regione: 'Veneto' },
  { codice: '028', nome: 'Padova', sigla: 'PD', regione: 'Veneto' },
  { codice: '029', nome: 'Rovigo', sigla: 'RO', regione: 'Veneto' },
  { codice: '030', nome: 'Udine', sigla: 'UD', regione: 'Friuli Venezia Giulia' },
  { codice: '031', nome: 'Gorizia', sigla: 'GO', regione: 'Friuli Venezia Giulia' },
  { codice: '032', nome: 'Trieste', sigla: 'TS', regione: 'Friuli Venezia Giulia' },
  { codice: '033', nome: 'Piacenza', sigla: 'PC', regione: 'Emilia Romagna' },
  { codice: '034', nome: 'Parma', sigla: 'PR', regione: 'Emilia Romagna' },
  { codice: '035', nome: 'Reggio nell\'Emilia', sigla: 'RE', regione: 'Emilia Romagna' },
  { codice: '036', nome: 'Modena', sigla: 'MO', regione: 'Emilia Romagna' },
  { codice: '037', nome: 'Bologna', sigla: 'BO', regione: 'Emilia Romagna' },
  { codice: '038', nome: 'Ferrara', sigla: 'FE', regione: 'Emilia Romagna' },
  { codice: '039', nome: 'Ravenna', sigla: 'RA', regione: 'Emilia Romagna' },
  { codice: '040', nome: 'Forlì-Cesena', sigla: 'FC', regione: 'Emilia Romagna' },
  { codice: '041', nome: 'Pesaro e Urbino', sigla: 'PU', regione: 'Marche' },
  { codice: '042', nome: 'Ancona', sigla: 'AN', regione: 'Marche' },
  { codice: '043', nome: 'Macerata', sigla: 'MC', regione: 'Marche' },
  { codice: '044', nome: 'Ascoli Piceno', sigla: 'AP', regione: 'Marche' },
  { codice: '045', nome: 'Massa-Carrara', sigla: 'MS', regione: 'Toscana' },
  { codice: '046', nome: 'Lucca', sigla: 'LU', regione: 'Toscana' },
  { codice: '047', nome: 'Pistoia', sigla: 'PT', regione: 'Toscana' },
  { codice: '048', nome: 'Firenze', sigla: 'FI', regione: 'Toscana' },
  { codice: '049', nome: 'Livorno', sigla: 'LI', regione: 'Toscana' },
  { codice: '050', nome: 'Pisa', sigla: 'PI', regione: 'Toscana' },
  { codice: '051', nome: 'Arezzo', sigla: 'AR', regione: 'Toscana' },
  { codice: '052', nome: 'Siena', sigla: 'SI', regione: 'Toscana' },
  { codice: '053', nome: 'Grosseto', sigla: 'GR', regione: 'Toscana' },
  { codice: '054', nome: 'Perugia', sigla: 'PG', regione: 'Umbria' },
  { codice: '055', nome: 'Terni', sigla: 'TR', regione: 'Umbria' },
  { codice: '056', nome: 'Viterbo', sigla: 'VT', regione: 'Lazio' },
  { codice: '057', nome: 'Rieti', sigla: 'RI', regione: 'Lazio' },
  { codice: '058', nome: 'Roma', sigla: 'RM', regione: 'Lazio' },
  { codice: '059', nome: 'Latina', sigla: 'LT', regione: 'Lazio' },
  { codice: '060', nome: 'Frosinone', sigla: 'FR', regione: 'Lazio' },
  { codice: '061', nome: 'Caserta', sigla: 'CE', regione: 'Campania' },
  { codice: '062', nome: 'Benevento', sigla: 'BN', regione: 'Campania' },
  { codice: '063', nome: 'Napoli', sigla: 'NA', regione: 'Campania' },
  { codice: '064', nome: 'Avellino', sigla: 'AV', regione: 'Campania' },
  { codice: '065', nome: 'Salerno', sigla: 'SA', regione: 'Campania' },
  { codice: '066', nome: 'L\'Aquila', sigla: 'AQ', regione: 'Abruzzo' },
  { codice: '067', nome: 'Teramo', sigla: 'TE', regione: 'Abruzzo' },
  { codice: '068', nome: 'Pescara', sigla: 'PE', regione: 'Abruzzo' },
  { codice: '069', nome: 'Chieti', sigla: 'CH', regione: 'Abruzzo' },
  { codice: '070', nome: 'Campobasso', sigla: 'CB', regione: 'Molise' },
  { codice: '071', nome: 'Foggia', sigla: 'FG', regione: 'Puglia' },
  { codice: '072', nome: 'Bari', sigla: 'BA', regione: 'Puglia' },
  { codice: '073', nome: 'Taranto', sigla: 'TA', regione: 'Puglia' },
  { codice: '074', nome: 'Brindisi', sigla: 'BR', regione: 'Puglia' },
  { codice: '075', nome: 'Lecce', sigla: 'LE', regione: 'Puglia' },
  { codice: '076', nome: 'Potenza', sigla: 'PZ', regione: 'Basilicata' },
  { codice: '077', nome: 'Matera', sigla: 'MT', regione: 'Basilicata' },
  { codice: '078', nome: 'Cosenza', sigla: 'CS', regione: 'Calabria' },
  { codice: '079', nome: 'Catanzaro', sigla: 'CZ', regione: 'Calabria' },
  { codice: '080', nome: 'Reggio Calabria', sigla: 'RC', regione: 'Calabria' },
  { codice: '081', nome: 'Trapani', sigla: 'TP', regione: 'Sicilia' },
  { codice: '082', nome: 'Palermo', sigla: 'PA', regione: 'Sicilia' },
  { codice: '083', nome: 'Messina', sigla: 'ME', regione: 'Sicilia' },
  { codice: '084', nome: 'Agrigento', sigla: 'AG', regione: 'Sicilia' },
  { codice: '085', nome: 'Caltanissetta', sigla: 'CL', regione: 'Sicilia' },
  { codice: '086', nome: 'Enna', sigla: 'EN', regione: 'Sicilia' },
  { codice: '087', nome: 'Catania', sigla: 'CT', regione: 'Sicilia' },
  { codice: '088', nome: 'Ragusa', sigla: 'RG', regione: 'Sicilia' },
  { codice: '089', nome: 'Siracusa', sigla: 'SR', regione: 'Sicilia' },
  { codice: '090', nome: 'Sassari', sigla: 'SS', regione: 'Sardegna' },
  { codice: '091', nome: 'Nuoro', sigla: 'NU', regione: 'Sardegna' },
  { codice: '092', nome: 'Cagliari', sigla: 'CA', regione: 'Sardegna' },
  { codice: '093', nome: 'Pordenone', sigla: 'PN', regione: 'Friuli Venezia Giulia' },
  { codice: '094', nome: 'Isernia', sigla: 'IS', regione: 'Molise' },
  { codice: '095', nome: 'Oristano', sigla: 'OR', regione: 'Sardegna' },
  { codice: '096', nome: 'Biella', sigla: 'BI', regione: 'Piemonte' },
  { codice: '097', nome: 'Lecco', sigla: 'LC', regione: 'Lombardia' },
  { codice: '098', nome: 'Lodi', sigla: 'LO', regione: 'Lombardia' },
  { codice: '099', nome: 'Rimini', sigla: 'RN', regione: 'Emilia Romagna' },
  { codice: '100', nome: 'Prato', sigla: 'PO', regione: 'Toscana' },
  { codice: '101', nome: 'Crotone', sigla: 'KR', regione: 'Calabria' },
  { codice: '102', nome: 'Vibo Valentia', sigla: 'VV', regione: 'Calabria' },
  { codice: '103', nome: 'Verbano-Cusio-Ossola', sigla: 'VB', regione: 'Piemonte' },
  { codice: '108', nome: 'Monza e della Brianza', sigla: 'MB', regione: 'Lombardia' },
  { codice: '109', nome: 'Fermo', sigla: 'FM', regione: 'Marche' },
  { codice: '110', nome: 'Barletta-Andria-Trani', sigla: 'BT', regione: 'Puglia' },
  { codice: '111', nome: 'Sud Sardegna', sigla: 'SU', regione: 'Sardegna' }
];

// Componente ClientForm semplificato per uso interno alla pratica
const ClientFormForPratica = ({ clienteData, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    tipo_cliente: 'privato',
    nome: '',
    cognome: '',
    codice_fiscale: '',
    tipo_contratto: '',
    ragione_sociale: '',
    partita_iva: '',
    referente: '',
    pec: '',
    codice_univoco: '',
    tipo_societa: '',
    indirizzo: '',
    citta: '',
    provincia: '',
    cap: '',
    email: '',
    telefono: '',
    iban: '',
    stato: 'attivo',
    ...clienteData
  });
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [modificati, setModificati] = useState({});

  // Stati per i dropdown avanzati
  const [showProvinciaDropdown, setShowProvinciaDropdown] = useState(false);
  const [showCittaDropdown, setShowCittaDropdown] = useState(false);
  const [provinciaSearch, setProvinciaSearch] = useState('');
  const [cittaSearch, setCittaSearch] = useState('');
  const [availableComuni, setAvailableComuni] = useState([]);
  const [filteredComuni, setFilteredComuni] = useState([]);
  const [loadingComuni, setLoadingComuni] = useState(false);

  // Filtra le province in base alla ricerca (identico al ClientForm originale)
  const filteredProvince = PROVINCE_ITALIANE.filter(provincia => 
    provincia.nome.toLowerCase().includes(provinciaSearch.toLowerCase()) ||
    provincia.sigla.toLowerCase().includes(provinciaSearch.toLowerCase()) ||
    provincia.regione.toLowerCase().includes(provinciaSearch.toLowerCase())
  );

  // Trova la provincia selezionata per mostrare il nome completo
  const selectedProvincia = PROVINCE_ITALIANE.find(p => p.sigla === formData.provincia);
  const provinciaDisplayText = selectedProvincia 
    ? `${selectedProvincia.nome} (${selectedProvincia.sigla}) - ${selectedProvincia.regione}`
    : '';

  // Carica i comuni quando cambia la provincia (identico al ClientForm originale)
  useEffect(() => {
    const loadComuni = async () => {
      if (formData.provincia) {
        setLoadingComuni(true);
        try {
          const comuni = await getComuniByProvincia(formData.provincia);
          setAvailableComuni(comuni);
          setFilteredComuni(comuni);
        } catch (error) {
          console.error('Errore nel caricamento comuni:', error);
          setAvailableComuni(getDefaultComuni());
          setFilteredComuni(getDefaultComuni());
        } finally {
          setLoadingComuni(false);
        }
      } else {
        setAvailableComuni(getDefaultComuni());
        setFilteredComuni(getDefaultComuni());
      }
    };
    
    loadComuni();
  }, [formData.provincia]);

  // Filtra i comuni in base alla ricerca (identico al ClientForm originale)
  useEffect(() => {
    const filterComuni = async () => {
      if (cittaSearch.length >= 2 && formData.provincia) {
        setLoadingComuni(true);
        try {
          const risultati = await searchComuni(cittaSearch, formData.provincia);
          setFilteredComuni(risultati);
        } catch (error) {
          console.error('Errore nella ricerca comuni:', error);
          setFilteredComuni([]);
        } finally {
          setLoadingComuni(false);
        }
      } else {
        setFilteredComuni(availableComuni);
      }
    };
    
    const debounceTimer = setTimeout(filterComuni, 300);
    return () => clearTimeout(debounceTimer);
  }, [cittaSearch, availableComuni, formData.provincia]);

  // Chiudi dropdown quando si clicca fuori (identico al ClientForm originale)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('[data-dropdown]')) {
        setShowProvinciaDropdown(false);
        setShowCittaDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Funzione per selezionare provincia (identica al ClientForm originale)
  const handleSelectProvincia = (provincia) => {
    handleChange({ target: { name: 'provincia', value: provincia.sigla } });
    setProvinciaSearch('');
    setShowProvinciaDropdown(false);
    // Reset città quando cambia provincia
    handleChange({ target: { name: 'citta', value: '' } });
  };

  // Funzione per selezionare città (identica al ClientForm originale)
  const handleSelectCitta = (comune) => {
    handleChange({ target: { name: 'citta', value: comune.nome } });
    setCittaSearch('');
    setShowCittaDropdown(false);
  };

  // Traccia i campi modificati
  const handleChange = (e) => {
    const { name, value } = e.target;
    const originalValue = clienteData[name] || '';
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Segna il campo come modificato se diverso dall'originale
    setModificati(prev => ({
      ...prev,
      [name]: value !== originalValue
    }));

    // Rimuovi errore per questo campo
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  // Validazioni specifiche
  const handleCodiceFiscaleChange = (value) => {
    const valueUpperCase = value.toUpperCase();
    if (value === '' || valueUpperCase.length <= 16) {
      handleChange({ target: { name: 'codice_fiscale', value: valueUpperCase } });
    }
  };

  const handleCapChange = (value) => {
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue.length <= 5) {
      handleChange({ target: { name: 'cap', value: numericValue } });
    }
  };

  const handleIbanChange = (value) => {
    const cleanValue = value.toUpperCase().replace(/\s/g, '');
    handleChange({ target: { name: 'iban', value: cleanValue } });
  };

  const validateForm = () => {
    const newErrors = {};

    if (formData.tipo_cliente === 'privato') {
      if (!formData.nome) newErrors.nome = 'Il nome è obbligatorio';
      if (!formData.cognome) newErrors.cognome = 'Il cognome è obbligatorio';
    } else {
      if (!formData.ragione_sociale) newErrors.ragione_sociale = 'La ragione sociale è obbligatoria';
    }

    if (!formData.email) {
      newErrors.email = 'L\'email è obbligatoria';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email non valida';
    }

    if (!formData.telefono) newErrors.telefono = 'Il telefono è obbligatorio';

    if (formData.codice_fiscale && formData.codice_fiscale.length !== 16) {
      newErrors.codice_fiscale = 'Il codice fiscale deve essere di 16 caratteri';
    }

    if (formData.cap && (formData.cap.length !== 5 || !/^\d{5}$/.test(formData.cap))) {
      newErrors.cap = 'Il CAP deve essere di 5 cifre';
    }

    if (formData.provincia && !PROVINCE_ITALIANE.find(p => p.sigla === formData.provincia)) {
      newErrors.provincia = 'Seleziona una provincia valida dalla lista';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    // Prepara solo i campi modificati
    const campiModificati = {};
    Object.keys(modificati).forEach(key => {
      if (modificati[key]) {
        const value = formData[key];
        campiModificati[key] = value === '' ? null : value;
      }
    });

    if (Object.keys(campiModificati).length === 0) {
        toast.info('Nessuna modifica da salvare');
        return;
      }

    setSaving(true);
    try {
      await api.updateClient(clienteData.id, campiModificati);
      toast.success('Dati cliente aggiornati con successo');
      onSave(campiModificati);
      setModificati({});
    } catch (error) {
      console.error('Errore aggiornamento cliente:', error);
      if (error.response?.data?.errors && Array.isArray(error.response.data.errors)) {
        const errori = error.response.data.errors.map(err => {
          if (typeof err === 'object' && err.msg) return err.msg;
          if (typeof err === 'object' && err.message) return err.message;
          if (typeof err === 'string') return err;
          return 'Errore di validazione';
        }).join(', ');
        toast.error(`Errore di validazione: ${errori}`);
      } else {
        toast.error('Errore nell\'aggiornamento dei dati cliente');
      }
    } finally {
      setSaving(false);
    }
  };

  const getFieldClasses = (fieldName) => {
    const baseClasses = "w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-blue-500 focus:border-blue-500";
    const isModified = modificati[fieldName];
    const hasError = errors[fieldName];
    
    if (hasError) return `${baseClasses} border-red-300 bg-red-50`;
    if (isModified) return `${baseClasses} border-yellow-400 bg-yellow-50`;
    return `${baseClasses} border-gray-300`;
  };

  const campiModificatiCount = Object.values(modificati).filter(Boolean).length;

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Messaggio informativo per i campi modificati */}
      {campiModificatiCount > 0 && (
        <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-md">
          <div className="flex items-center">
            <InformationCircleIcon className="h-5 w-5 text-yellow-600 mr-3" />
            <p className="text-sm text-yellow-700">
              Hai {campiModificatiCount} campo{campiModificatiCount !== 1 ? 'i' : ''} modificat{campiModificatiCount !== 1 ? 'i' : 'o'} (evidenziati in giallo). 
              Clicca "Salva Modifiche" per confermare.
            </p>
          </div>
        </div>
      )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Colonna Sinistra - Informazioni Generali */}
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900 border-b pb-2">Informazioni Generali</h4>
            
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Tipo Cliente *</label>
              <select
              name="tipo_cliente"
              value={formData.tipo_cliente}
              onChange={handleChange}
              className={getFieldClasses('tipo_cliente')}
              >
                <option value="privato">Privato</option>
                <option value="azienda">Azienda</option>
              </select>
            </div>

          {(formData.tipo_cliente === 'azienda' || formData.tipo_cliente === 'aziendale') ? (
              <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Ragione Sociale *</label>
                <input
                  type="text"
                name="ragione_sociale"
                value={formData.ragione_sociale}
                onChange={handleChange}
                className={getFieldClasses('ragione_sociale')}
                  placeholder="Inserisci ragione sociale"
                />
              {errors.ragione_sociale && <p className="text-red-500 text-xs mt-1">{errors.ragione_sociale}</p>}
              </div>
            ) : (
              <>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome *</label>
                  <input
                    type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  className={getFieldClasses('nome')}
                    placeholder="Inserisci nome"
                  />
                {errors.nome && <p className="text-red-500 text-xs mt-1">{errors.nome}</p>}
                </div>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Cognome *</label>
                  <input
                    type="text"
                  name="cognome"
                  value={formData.cognome}
                  onChange={handleChange}
                  className={getFieldClasses('cognome')}
                    placeholder="Inserisci cognome"
                  />
                {errors.cognome && <p className="text-red-500 text-xs mt-1">{errors.cognome}</p>}
                </div>
                
                {/* Codice Fiscale - SOLO PER PRIVATI */}
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Codice Fiscale</label>
                  <input
                    type="text"
                  value={formData.codice_fiscale}
                    onChange={(e) => handleCodiceFiscaleChange(e.target.value)}
                  className={getFieldClasses('codice_fiscale')}
                    placeholder="Inserisci codice fiscale (16 caratteri)"
                    maxLength="16"
                  />
                {errors.codice_fiscale && <p className="text-red-500 text-xs mt-1">{errors.codice_fiscale}</p>}
                </div>

                {/* Tipo di Contratto - SOLO PER PRIVATI */}
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo di contratto</label>
                  <select
                  name="tipo_contratto"
                  value={formData.tipo_contratto}
                  onChange={handleChange}
                  className={getFieldClasses('tipo_contratto')}
                  >
                    <option value="">Seleziona...</option>
                    <option value="tempo_indeterminato">Dipendente con contratto a tempo Indeterminato</option>
                    <option value="tempo_indeterminato_meno_6_mesi">Dipendente con contratto a tempo Indeterminato da meno di 6 mesi</option>
                    <option value="pensionato">Pensionato</option>
                    <option value="reddito_modello_unico">Privato con reddito modello unico</option>
                  </select>
                </div>
              </>
            )}

          {(formData.tipo_cliente === 'azienda' || formData.tipo_cliente === 'aziendale') && (
              <>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Partita IVA</label>
                  <input
                    type="text"
                  name="partita_iva"
                  value={formData.partita_iva}
                  onChange={handleChange}
                  className={getFieldClasses('partita_iva')}
                    placeholder="Inserisci partita IVA"
                    maxLength="11"
                  />
                </div>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipologia Azienda *
                  <span className="text-xs font-normal text-gray-500 ml-2">(Determina i documenti richiesti)</span>
                </label>
                  <select
                  name="tipo_societa_dettaglio"
                  value={formData.tipo_societa_dettaglio || ''}
                  onChange={handleChange}
                  className={getFieldClasses('tipo_societa_dettaglio')}
                  required
                  >
                    <option value="">Seleziona tipologia...</option>
                    <optgroup label="Professionisti e Imprese Individuali">
                      <option value="libero_professionista">Libero Professionista</option>
                      <option value="ditta_individuale">Ditta Individuale</option>
                    </optgroup>
                    <optgroup label="Società">
                      <option value="societa_persone">Società di Persone (SNC, SAS)</option>
                      <option value="societa_capitali">Società di Capitali (SRL, SPA, SAPA)</option>
                      <option value="societa_estere">Società Estera</option>
                    </optgroup>
                    <optgroup label="Enti e Altri">
                      <option value="consorzi_onlus">Consorzio / ONLUS / Associazione</option>
                      <option value="pensionati">Pensionato (come azienda)</option>
                    </optgroup>
                  </select>
                {errors.tipo_societa_dettaglio && <p className="text-red-500 text-xs mt-1">{errors.tipo_societa_dettaglio}</p>}
                  <p className="text-xs text-gray-500 mt-1">
                    ⚠️ Questa selezione determina quali documenti saranno richiesti
                  </p>
                </div>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Referente</label>
                  <input
                    type="text"
                  name="referente"
                  value={formData.referente}
                  onChange={handleChange}
                  className={getFieldClasses('referente')}
                    placeholder="Inserisci nome referente"
                  />
                </div>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">PEC</label>
                  <input
                    type="email"
                  name="pec"
                  value={formData.pec}
                  onChange={handleChange}
                  className={getFieldClasses('pec')}
                    placeholder="Inserisci PEC"
                  />
                </div>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Codice Univoco</label>
                  <input
                    type="text"
                  name="codice_univoco"
                  value={formData.codice_univoco}
                  onChange={handleChange}
                  className={getFieldClasses('codice_univoco')}
                    placeholder="Inserisci codice univoco"
                  />
                </div>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo Società</label>
                  <select
                  name="tipo_societa"
                  value={formData.tipo_societa}
                  onChange={handleChange}
                  className={getFieldClasses('tipo_societa')}
                  >
                    <option value="">Seleziona...</option>
                    <option value="libero_professionista_neocostituita">Libero professionista o società neocostituita</option>
                    <option value="libero_professionista_meno_2_bilanci">Libero professionista o società con meno di 2 bilanci depositati</option>
                    <option value="libero_professionista_piu_2_bilanci">Libero professionista o società con più di 2 bilanci depositati</option>
                  </select>
                </div>
              </>
            )}

            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Stato Cliente</label>
              <select
              name="stato"
              value={formData.stato}
              onChange={handleChange}
              className={getFieldClasses('stato')}
              >
                <option value="attivo">Attivo</option>
                <option value="prospect">Prospect</option>
                <option value="qualificato">Qualificato</option>
                <option value="sospeso">Sospeso</option>
                <option value="inattivo">Inattivo</option>
              </select>
            </div>
          </div>
          
          {/* Colonna Destra - Contatti e Indirizzo */}
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900 border-b pb-2">Contatti e Indirizzo</h4>
            
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
              <input
                type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={getFieldClasses('email')}
                placeholder="Inserisci email"
              />
            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
            </div>
            
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Telefono *</label>
              <input
                type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              className={getFieldClasses('telefono')}
                placeholder="Inserisci telefono"
              />
            {errors.telefono && <p className="text-red-500 text-xs mt-1">{errors.telefono}</p>}
            </div>
            
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Indirizzo</label>
              <input
                type="text"
              name="indirizzo"
              value={formData.indirizzo}
              onChange={handleChange}
              className={getFieldClasses('indirizzo')}
                placeholder="Inserisci indirizzo"
              />
            </div>
            
          <div className="grid grid-cols-2 gap-4">
            <div className="relative" data-dropdown>
              <label className="block text-sm font-medium text-gray-700 mb-2">Provincia</label>
              <div className="relative">
                <input
                  type="text"
                  value={showProvinciaDropdown ? provinciaSearch : (formData.provincia ? `${formData.provincia} - ${provinciaDisplayText}` : '')}
                  onChange={(e) => {
                    setProvinciaSearch(e.target.value);
                    if (!showProvinciaDropdown) setShowProvinciaDropdown(true);
                  }}
                  onFocus={() => setShowProvinciaDropdown(true)}
                  className={getFieldClasses('provincia')}
                  placeholder="Cerca provincia..."
                />
                <ChevronDownIcon className="h-5 w-5 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none" />
              </div>
              
              {showProvinciaDropdown && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                  <div className="p-2 border-b border-gray-200">
                    <div className="relative">
                      <MagnifyingGlassIcon className="h-4 w-4 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
              <input
                type="text"
                        value={provinciaSearch}
                        onChange={(e) => setProvinciaSearch(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Cerca provincia..."
                        autoFocus
                      />
                    </div>
                  </div>
                  <div className="max-h-48 overflow-y-auto">
                    {filteredProvince.length > 0 ? (
                      filteredProvince.map((provincia) => (
                        <button
                          key={provincia.sigla}
                          type="button"
                          onClick={() => handleSelectProvincia(provincia)}
                          className="w-full text-left px-3 py-2 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none text-sm"
                        >
                          <div className="font-medium">{provincia.nome} ({provincia.sigla})</div>
                          <div className="text-xs text-gray-500">{provincia.regione}</div>
                        </button>
                      ))
                    ) : (
                      <div className="px-3 py-2 text-sm text-gray-500">
                        Nessuna provincia trovata
                      </div>
                    )}
                  </div>
                </div>
              )}
              {errors.provincia && <p className="text-red-500 text-xs mt-1">{errors.provincia}</p>}
            </div>
            
            <div className="relative" data-dropdown>
              <label className="block text-sm font-medium text-gray-700 mb-2">Città</label>
              <div className="relative">
                <input
                  type="text"
                  value={showCittaDropdown ? cittaSearch : formData.citta}
                  onChange={(e) => {
                    if (showCittaDropdown) {
                      setCittaSearch(e.target.value);
                    } else {
                      handleChange({ target: { name: 'citta', value: e.target.value } });
                    }
                  }}
                  onFocus={() => {
                    if (formData.provincia) {
                      setShowCittaDropdown(true);
                      setCittaSearch(formData.citta);
                    }
                  }}
                  className={getFieldClasses('citta')}
                  placeholder={formData.provincia ? "Cerca città..." : "Seleziona prima una provincia"}
                  disabled={!formData.provincia}
                />
                {formData.provincia && (
                  <ChevronDownIcon className="h-5 w-5 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none" />
                )}
              </div>
              
              {showCittaDropdown && formData.provincia && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                  <div className="p-2 border-b border-gray-200">
                    <div className="relative">
                      <MagnifyingGlassIcon className="h-4 w-4 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                      <input
                        type="text"
                        value={cittaSearch}
                        onChange={(e) => setCittaSearch(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Cerca città..."
                        autoFocus
                      />
                    </div>
                  </div>
                  <div className="max-h-48 overflow-y-auto">
                    {loadingComuni ? (
                      <div className="px-3 py-2 text-sm text-gray-500 flex items-center">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                        Caricamento comuni...
                      </div>
                    ) : filteredComuni.length > 0 ? (
                      filteredComuni.map((comune) => (
                        <button
                          key={comune.codice || comune.nome}
                          type="button"
                          onClick={() => handleSelectCitta(comune)}
                          className="w-full text-left px-3 py-2 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none text-sm"
                        >
                          <div className="font-medium">{comune.nome}</div>
                          {comune.cap && (
                            <div className="text-xs text-gray-500">CAP: {comune.cap}</div>
                          )}
                        </button>
                      ))
                    ) : (
                      <div className="px-3 py-2 text-sm text-gray-500">
                        {cittaSearch.length < 2 
                          ? "Digita almeno 2 caratteri per cercare"
                          : "Nessuna città trovata"
                        }
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

              <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">CAP</label>
                <input
                  type="text"
              value={formData.cap}
              onChange={(e) => handleCapChange(e.target.value)}
              className={getFieldClasses('cap')}
                  placeholder="CAP"
                  maxLength="5"
                />
            {errors.cap && <p className="text-red-500 text-xs mt-1">{errors.cap}</p>}
            </div>

            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">IBAN</label>
              <input
                type="text"
              value={formData.iban}
              onChange={(e) => handleIbanChange(e.target.value)}
              className={getFieldClasses('iban')}
                placeholder="Inserisci IBAN"
              />
            </div>
          </div>
        </div>

      {/* Pulsante Salva */}
      <div className="flex justify-end pt-4 border-t">
        <button
          type="submit"
          disabled={saving || campiModificatiCount === 0}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
        >
          {saving ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
          ) : (
            <CheckCircleIcon className="h-4 w-4 mr-2" />
          )}
          Salva Modifiche {campiModificatiCount > 0 && `(${campiModificatiCount})`}
        </button>
      </div>
    </form>
  );
};

const TabAnagrafica = ({ pratica, onDatiAggiornati, isCampoModificabileAgente }) => {
  const handleSave = (modifiche) => {
    // Callback per aggiornare i dati della pratica
    if (onDatiAggiornati) {
      onDatiAggiornati();
    }
  };

  if (!pratica || !pratica.cliente) {
    return (
      <div className="bg-white rounded-lg shadow-sm border p-6 text-center">
        <p className="text-gray-500">Nessun dato cliente disponibile</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="px-6 py-4 border-b bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-900">Anagrafica Completa</h3>
      </div>
      <div className="p-6">
        <ClientFormForPratica
          clienteData={pratica.cliente}
          onSave={handleSave}
        />
      </div>
    </div>
  );
};

export default TabAnagrafica; 